import {
  CANVAS_DAMAGE_FAILED,
  CANVAS_DAMAGE_REQUEST,
  CANVAS_DAMAGE_SUCCESS,
} from "../../../../actions/Factory/Canvas/canvasDamage/constant";

const INIT_STATE = {
  loading: false,
  totalPage: 0,
  data: [],
  error: {
    isError: false,
    message: null,
  },
};

export const canvasDamageReducer = function (
  state = INIT_STATE,
  action
) {
  switch (action?.type) {
    case CANVAS_DAMAGE_REQUEST:
      return {
        loading: true,
        totalPage: 0,
        data: [],
        error: {
          isError: false,
          message: null,
        },
      };
    case CANVAS_DAMAGE_SUCCESS:
      return {
        loading: false,
        data: action?.payload?.data,
        totalPage: action?.payload?.totalPage,
        error: {
          isError: false,
          message: null,
        },
      };
    case CANVAS_DAMAGE_FAILED:
      const { isError = true, message = "Something Went Wrong" } =
        action?.payload?.error || {};
      return {
        loading: false,
        totalPage: 0,
        data: [],
        error: {
          isError: isError,
          message: message,
        },
      };
    default:
      return state;
  }
};
